module.exports = new __parcel__URL__("softcomputers_booklet2.5b025938.jpg").toString();